export default __webpack_public_path__ + "static/media/export.2b21b5b2.svg";